import { render } from "./ApartmentsNotes.vue?vue&type=template&id=74dbce6a"
import script from "./ApartmentsNotes.vue?vue&type=script&lang=js"
export * from "./ApartmentsNotes.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__